import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-common-validation-error",
	templateUrl: "./common-validation-error.component.html",
	styleUrls: ["./common-validation-error.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonValidationErrorComponent {
	@HostBinding("class.obg-common-validation-error") hostCssClass = true;

	@Input() errorMessage: string | undefined;
	@Input() testId: string | undefined;
}
